import { http } from "@/http";

export default {
  list(params) {
    return http.get("/api/v1/admin/banner", { params });
  },
  get(id) {
    return http.get(`/api/v1/admin/banner/${id}`);
  },
  save(payload) {
    return http.post("/api/v1/admin/banner", payload);
  },
  update(id, payload) {
    return http.put(`/api/v1/admin/banner/${id}`, payload);
  },
  toggleStatus(id, isActive ) {
    return http.put(`/api/v1/admin/banner/${id}/active`, null, {
      params: {
        isActive
      }
    });
  },
  delete(id) {
    return http.delete(`/api/v1/admin/banner/${id}`);
  },
};